/**
 *  配电表计管理
 */
import * as HttpService from "../../../../service/HttpService";

/**
 * 查询模板列表
 */
export const queryTempList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/reportTmpl/getReportTmplCustomBySearch", params);
};

/**
 * 查询预览列表
 */
export const queryPreviewList = (params) => {
    // return HttpService.get(HttpService.DOMAIN + "/reportData/getPreviewList?id="+id);
    return HttpService.post(HttpService.DOMAIN + "/report/custom/generateCustMeasDataList",params);

};

/**
 * 查询预览列表
 */
export const queryPreviewTimeList = (params) => {
    // return HttpService.get(HttpService.DOMAIN + "/reportData/getPreviewList?id="+id);
    return HttpService.post(HttpService.DOMAIN + "/report/dateTime/getReportDataTimeGenerateList",params);

};

/**
 * 获取columns    --
 */
export const getColumns = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/dailyReport/getColumns",params);
};

/**
 * 生成报表
 */
export const addOneReportCustMeasDataCustom = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/reportData/addOneReportCustMeasDataCustom",params);
};
